<template>
  <div class="import-offline-data-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <h2>{{ currentMonth }} 医生薪酬线下数据</h2>
      <el-button type="primary" @click="openImportDialog" class="import-btn">
        <i class="el-icon-plus"></i>导入
      </el-button>
    </div>

    <!-- 搜索区域 -->
    <el-form class="search-form" :model="searchForm" inline size="small">
      <el-form-item label="医生姓名">
        <el-input
          v-model="searchForm.doctorName"
          placeholder="请输入医生姓名"
          clearable
        />
      </el-form-item>
      <el-form-item label="员工编号">
        <el-input
          v-model="searchForm.employeeNo"
          placeholder="请输入员工编号"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 表格区域 -->
    <div class="table-wrap">
      <el-table
        class="data-table"
        :data="tableData"
        border
        :cell-style="{ borderColor: '#dcdfe6' }"
        :header-cell-style="{ background: '#f5f7fa', borderColor: '#dcdfe6', color: '#333333' }"
      >
        <el-table-column prop="doctorName" label="医生姓名" />
        <el-table-column prop="employeeNo" label="员工编号" />
        <el-table-column prop="storeCode" label="门店编码" />
        <el-table-column prop="trafficAllowance" label="交通补贴金额" />
        <el-table-column prop="meituanRegistrationFee" label="美团挂号费" />
      </el-table>

      <!-- 分页 -->
      <div class="page-wrap">
        <el-pagination
          background
          layout="sizes,total, prev, pager, next, jumper"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="searchForm.pageSize"
          :current-page="searchForm.pageNum"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>


    <!-- 导入弹窗 -->
    <el-dialog title="导入线下数据" :visible.sync="importDialogVisible" width="420px">
      <div class="import-dialog-content">
        <div class="import-tip">
          <p>导入线下数据</p>
          <p class="tip-text">重新导入会覆盖所有历史导入的数据</p>
        </div>
        <div class="template-download">
          <span class="template-label">下载导入模板</span>
          <el-button type="text" @click="handleTemplateDownload">点击下载</el-button>
        </div>
        <el-upload
          class="upload-box"
          action=""
          accept=".xls,.xlsx"
          :auto-upload="false"
          :limit="1"
          :file-list="fileList"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
        >
          <el-button size="small">选择文件</el-button>
          <span slot="tip" class="upload-tip">请上传Excel文件</span>
        </el-upload>
      </div>
      <span slot="footer">
        <el-button @click="importDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleImport">确定</el-button>
      </span>
    </el-dialog>

    <!-- 导入成功提示 -->
    <el-popover
      ref="successPopover"
      placement="top"
      width="200"
      trigger="manual"
    >
      <div class="success-tip">
        <i class="el-icon-check-circle"></i>
        <span>导入成功</span>
      </div>
    </el-popover>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'ImportOfflineData',
  data() {
    return {
      currentMonth: '',
      importDialogVisible: false,
      fileList: [],
      searchForm: {
        doctorName: '',
        employeeNo: '',
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      tableData: [
        {
          doctorName: '张三',
          employeeNo: 'EMP001',
          storeCode: 'STORE001',
          trafficAllowance: '500.00',
          meituanRegistrationFee: '200.00'
        },
        {
          doctorName: '李四',
          employeeNo: 'EMP002',
          storeCode: 'STORE002',
          trafficAllowance: '300.00',
          meituanRegistrationFee: '150.00'
        },
        {
          doctorName: '王五',
          employeeNo: 'EMP003',
          storeCode: 'STORE001',
          trafficAllowance: '400.00',
          meituanRegistrationFee: '180.00'
        }
      ]
    };
  },
  mounted() {
    // 获取URL参数中的月份，如果没有则使用当前月份
    const month = this.$route.query.month || moment().format('YYYY-MM');
    this.currentMonth = month;
    this.handleSearch();
  },
  methods: {
    handleSearch() {
      this.searchForm.pageNum = 1;
      // 模拟查询数据
      this.total = this.tableData.length;
    },
    handleReset() {
      this.searchForm = {
        doctorName: '',
        employeeNo: '',
        pageNum: 1,
        pageSize: 10
      };
      this.handleSearch();
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.searchForm.pageNum = 1;
    },
    handleCurrentChange(pageNum) {
      this.searchForm.pageNum = pageNum;
    },
    openImportDialog() {
      this.fileList = [];
      this.importDialogVisible = true;
    },
    handleTemplateDownload() {
      this.$message.info('下载导入模板');
    },
    handleFileChange(file, fileList) {
      if (!file) return;
      this.fileList = fileList.slice(-1);
    },
    handleFileRemove(file, fileList) {
      if (!file) return;
      this.fileList = fileList;
    },
    handleImport() {
      if (!this.fileList.length) {
        this.$message.warning('请选择导入文件');
        return;
      }
      this.importDialogVisible = false;
      this.$message.success('导入成功');
    }
  }
};
</script>

<style lang="less" scoped>
.import-offline-data-page {
  padding: 16px;
  background: #ffffff;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    h2 {
      font-size: 18px;
      font-weight: 600;
      color: #333;
      margin: 0;
    }

    .import-btn {
      padding: 8px 20px;
    }
  }

  .search-form {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 12px;
    padding: 12px 16px;
    background: #f5f7fa;
    border-radius: 4px;

    /deep/ .el-form-item {
      margin-bottom: 8px;
      margin-right: 16px;

      &:last-child {
        margin-right: 0;
      }
    }

    /deep/ .el-input {
      width: 200px;
    }
  }

  .table-wrap {
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    overflow: auto;

    .data-table {
      width: 100%;
    }
  }

  .page-wrap {
    display: flex;
    justify-content: flex-end;
    padding: 12px 16px;
    background: #f5f7fa;
    border-top: 1px solid #e4e7ed;
  }


  .import-dialog-content {
    .import-tip {
      padding: 12px;
      background: #fff7e6;
      border-radius: 4px;
      margin-bottom: 16px;

      p {
        margin: 0;
        font-size: 14px;
        color: #d48806;

        &.tip-text {
          font-size: 12px;
          margin-top: 4px;
        }
      }
    }

    .template-download {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 12px;
      border-bottom: 1px solid #e4e7ed;
      margin-bottom: 16px;

      .template-label {
        font-size: 14px;
        color: #606266;
      }
    }

    .upload-box {
      margin-top: 8px;

      /deep/ .el-upload {
        display: block;
      }

      .upload-tip {
        margin-left: 10px;
        color: #909399;
        font-size: 12px;
      }
    }
  }

  .success-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;

    i {
      font-size: 24px;
      color: #67c23a;
      margin-right: 8px;
    }

    span {
      font-size: 14px;
      color: #67c23a;
      font-weight: 500;
    }
  }
}
</style>
